import React , {useState, useEffect} from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './components/navbar/Navbar';
import NavBarAnon from './components/navbar/NavbarAnon';

import Calendar from './components/calendar/Calendar'; // Import your Calendar component
import Leaderboard from './components/leaderboard/Leaderboard'; // Import your Leaderboard component
import SignUp from './components/signup/SignUp'
import './App.css'
// import Histogram from './Histogram'; // Import your Histogram component
import Cookies from 'js-cookie';
import SignIn from './components/signup/SignIn';
import firebaseApp from './firebase'
import { Spinner } from 'react-bootstrap';
let auth = firebaseApp.auth()


function loadUser(){
  const user = auth.currentUser;
  console.log(user)
  if (user){
    return true
  }
  return false
}
function App() {
  const [user, setUser] = useState(null)
  const [loading,setLoading] = useState(true)
  useEffect(()=>{
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        setUser(user);
        
        setLoading(false)
      } else {
        // User is signed out.
        setUser(null);
        setLoading(false)
      }
    });

    // Clean up the subscription when the component unmounts.
    return () => unsubscribe();

  },[])
  if (loading){
    return <Spinner />
  }
  else if (!user){
    return <Router> 
    
      <NavBarAnon />
      <Routes>
        <Route path="/" element={<SignUp />} />
        <Route path="/signin" element={<SignIn />} />
        <Route path="*" element={<SignUp />} />
      </Routes>
    
  </Router>
  }else{
  return (
    <Router>
      <div>
        <NavBar />
        <Routes>
          <Route path="/" element={<Calendar />} />
          <Route path="/leaderboard" element={<Leaderboard/>} />
          <Route path="/about" element={<div style={{textAlign:"center", fontFamily:"Poppins"}}>
            <h1 >Developed by 3amEngineer in collaboration with skiperonie</h1>
            <p>Let's beat the 2023 NNN</p>
          </div>} />
          <Route path="*" element={<Calendar />} />
        </Routes>
      </div>
    </Router>

  );
  }
}

export default App;